export const NON_STANDARD_STOCK_MIN_VALUE = 0.05;
export const STANDARD_BUY_MIN_VALUE = 0.01;
export const STANDARD_BUY_MAX_VALUE = 10000;

export const nonStandardStocks = new Set([
	'BKNG',
	'AMZN',
	'GOOGL',
	'AZO',
	'CMG',
	'NVR',
	'TSLA',
]);

export const minBuyValue = (ticker, investmentType) => {
	return nonStandardStocks.has(ticker)
		? NON_STANDARD_STOCK_MIN_VALUE
		: STANDARD_BUY_MIN_VALUE;
};

export const minBuyValidationMessage = (ticker, investmentType) => {
	return nonStandardStocks.has(ticker)
		? 'Enter an amount over $0.05 to purchase.'
		: 'Enter an amount over $0 to purchase.';
};
